/* Personal Message add-on — 2-step add, form-encoded, show msg only on add-on */
document.addEventListener('DOMContentLoaded', function () {
  // ✅ Ελέγχει πρώτα το flag από το Liquid
  if (!window.PV_ALLOW_PM) return; // Αν είναι false, δεν τρέχει τίποτα

  var mount = document.getElementById('pm-addon');
  if (!mount) return;

  var PM_VARIANT_ID = 55546263667032; // <- το δικό σου Variant ID
  var isGreek = (document.documentElement.lang || '').toLowerCase().indexOf('el') === 0;

  var T = isGreek ? {
    label: '✨ Προσθέστε προσωπικό μήνυμα στο πίσω μέρος (+5€)',
    placeholder: 'Γράψτε εδώ το μήνυμά σας (έως 200 χαρακτήρες)',
    counterSuf: ' / 200',
    emptyErr: 'Παρακαλώ γράψτε το μήνυμά σας (έως 200 χαρακτήρες).',
    ajaxErr: 'Παρουσιάστηκε σφάλμα στο καλάθι.',
    propName: 'Personal Message'
  } : {
    label: '✨ Add a personal message on the back (+5€)',
    placeholder: 'Write your message here (up to 200 characters)',
    counterSuf: ' / 200',
    emptyErr: 'Please enter your message (up to 200 characters).',
    ajaxErr: 'Cart error.',
    propName: 'Personal Message'
  };

  // UI
  mount.innerHTML =
    '<div style="margin-top:20px;padding:15px;border:1px solid #ddd;border-radius:10px;">' +
      '<label style="display:flex;align-items:center;gap:8px;">' +
        '<input type="checkbox" id="pm-check">' + T.label +
      '</label>' +
      '<div id="pm-box" style="display:none;margin-top:10px;">' +
        '<textarea id="pm-text" maxlength="200" placeholder="'+ T.placeholder +'" ' +
          'style="width:100%;height:100px;border:1px solid #ccc;border-radius:6px;padding:8px;"></textarea>' +
        '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:6px;">' +
          '<small id="pm-count">0'+ T.counterSuf +'</small>' +
          '<small id="pm-err" style="color:#c00;display:none;">'+ T.emptyErr +'</small>' +
        '</div>' +
        '<div id="pm-ajax" style="display:none;color:#b00020;margin-top:8px;"></div>' +
      '</div>' +
    '</div>';

  var check  = document.getElementById('pm-check');
  var box    = document.getElementById('pm-box');
  var text   = document.getElementById('pm-text');
  var count  = document.getElementById('pm-count');
  var err    = document.getElementById('pm-err');
  var ajaxEr = document.getElementById('pm-ajax');

  check.addEventListener('change', function () {
    var on = !!this.checked;
    box.style.display = on ? 'block' : 'none';
    text.required = on;
    if (!on) { err.style.display = 'none'; ajaxEr.style.display = 'none'; ajaxEr.textContent = ''; }
  });

  text.addEventListener('input', function () {
    count.textContent = this.value.length + T.counterSuf;
    if (this.value.trim().length > 0) err.style.display = 'none';
  });

  var form = document.querySelector('product-form form') ||
             document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    if (!check.checked) return; // δεν ζήτησε add-on

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    var msg = (text.value || '').trim();
    if (!msg) { err.textContent = T.emptyErr; err.style.display = 'inline'; text.focus(); return; }
    ajaxEr.style.display = 'none'; ajaxEr.textContent = '';

    // Βήμα 1: πρόσθεσε το βασικό προϊόν όπως είναι (FormData)
    var fd = new FormData(form);

    fetch(form.getAttribute('action') || '/cart/add', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin'
    })
    .then(function(res){
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    })
    .then(function(){
      // Βήμα 2: πρόσθεσε το add-on ως ΜΟΝΟ item (form-encoded)
      var params = new URLSearchParams();
      params.set('id', String(PM_VARIANT_ID));
      params.set('quantity', '1');
      params.set('properties[' + T.propName + ']', msg);

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json' },
        body: params.toString(),
        credentials: 'same-origin'
      });
    })
    .then(function(res){
      if (!res.ok) {
        return res.json().then(function(j){ throw new Error(j && (j.description || j.message) || ('HTTP '+res.status)); });
      }
      window.location.href = '/cart';
    })
    .catch(function(errObj){
      ajaxEr.textContent = T.ajaxErr + (errObj && errObj.message ? errObj.message : 'Unexpected error');
      ajaxEr.style.display = 'block';
      console.error('Add-to-cart error:', errObj);
    });
  }, true);
});
